export const AssetsColumn = [
    { id: "desiredStatus", label: "desiredStatus", style: { custom: { width: 48 } } },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 48px)" } },
        disabled: true,
        checked: true,
        sortable: false,
    },
];

export default AssetsColumn;
